import React from "react";
import {Card} from "reactstrap";
import {useSelector, useDispatch} from "react-redux";
import Button from "../../../components/Button";
import TemplateListItem from "./templateListItem";
import ProtectedContent from "../../../components/protectedContent";
import {
  setTestFormVisibility,
  setNonTestFormVisibility,
  storeCreateTestData,
  requestNonTestTemplate,
  storeTestTemplateList,
  storeNonTestTemplate,
} from "../../../redux/Actions/reports.actions";
import {
  getNonTestTemplateList,
  getTestTemplateList,
} from "../../../redux/Selectors/reports.selectors";

const TestTemplatesList = () => {
  const dispatch = useDispatch();
  const nonTestTemplateList = useSelector(getNonTestTemplateList);
  const testTemplateList = useSelector(getTestTemplateList);

  const handleDelete = (template, type) => {
    if (type === "test") {
      let tempList = [...testTemplateList];
      tempList = tempList.filter((temp) => temp.value !== template.value);
      dispatch(storeTestTemplateList(tempList));
    } else {
      const filteredTemplateList = nonTestTemplateList.filter(
        (eachTemplate) => eachTemplate.value !== template.value
      );
      dispatch(storeNonTestTemplate([...filteredTemplateList]));
    }
  };

  const handleEdit = (template, type, index) => {
    if (type === "test") {
      dispatch(storeCreateTestData({...template, id: index + 1}));
      dispatch(setTestFormVisibility(true));
    } else {
      dispatch(requestNonTestTemplate(template.value));
      dispatch(setNonTestFormVisibility(true));
    }
  };

  return (
    <Card
      style={{
        padding: "1rem 0px",
        boxShadow: "0px 3px 6px #00000029",
      }}
    >
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 1rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        Add To Template
      </div>
      <div style={{marginBottom: "1rem"}}>
        {testTemplateList?.length > 0 && (
          <div style={{margin: "0px 1rem 0px 0px"}}>
            {testTemplateList?.map((template, index) => {
              return (
                <TemplateListItem
                  key={template.value}
                  content={template.label}
                  id={template.value}
                  onEdit={() => handleEdit(template, "test", index)}
                  onDelete={() => handleDelete(template, "test", index)}
                />
              );
            })}
          </div>
        )}
        {nonTestTemplateList?.length > 0 && (
          <ProtectedContent perms={["view_manualresulttemplate"]}>
            <div style={{margin: "0px 1rem 0px 0px"}}>
              {nonTestTemplateList?.map((template, index) => {
                return (
                  <TemplateListItem
                    key={template.value}
                    content={template.label}
                    id={template.value}
                    permsForEdit={["change_manualresulttemplate"]}
                    onEdit={() => handleEdit(template, "non-test", index)}
                    permsForDelete={["delete_manualresulttemplate"]}
                    onDelete={() => handleDelete(template, "non-test", index)}
                  />
                );
              })}
            </div>
          </ProtectedContent>
        )}
      </div>
      <div className="mr-sm-2 d-flex justify-content-center justify-content-sm-end">
        <Button
          withRadius
          onClick={() => dispatch(setTestFormVisibility(true))}
          data-cy="addResult"
        >
          ADD RESULT
        </Button>
        <ProtectedContent perms={["add_manualresulttemplate"]}>
          <Button
            withRadius
            onClick={() => dispatch(setNonTestFormVisibility(true))}
            data-cy="addManualResult"
          >
            ADD MANUAL RESULT
          </Button>
        </ProtectedContent>
      </div>
    </Card>
  );
};

export default TestTemplatesList;
